export const iconFontAwesomeConstructionScrewdriverWrench = (
	<i className="fa-solid fa-screwdriver-wrench"></i>
);
